/* Comparateur libre ROOK, refonte du 11/10/2026. La page arrive chiffrée par Shopify ; ce script ajoute :
   - le sélecteur à photos (toucher un pot) ;
   - sur l'outil (/pages/compare) : changement de pot sur place, adresse ?a=&b= ;
   - ailleurs (paire, fiche) : ouverture de la page de la paire choisie, ou de l'outil.
   Règles identiques aux snippets cmpx-* : malate converti, caféine comptée jusqu'à 200 mg, ND si citrulline ou bêta non déclarée. */
(() => {
  /* Carrousels de comparaisons : flèches gauche et droite (ordinateur) */
  document.querySelectorAll('.cx-block > .cx-scroll').forEach(sc => {
    const fr = document.documentElement.lang.startsWith('fr');
    const nav = document.createElement('div');
    nav.className = 'cx-nav';
    nav.innerHTML = `<button type="button" aria-label="${fr ? 'Précédent' : 'Previous'}"></button><button type="button" aria-label="${fr ? 'Suivant' : 'Next'}"></button>`;
    const [prev, next] = nav.children;
    const step = d => sc.scrollBy({left: d * sc.clientWidth * 0.8, behavior: 'smooth'});
    prev.addEventListener('click', () => step(-1));
    next.addEventListener('click', () => step(1));
    const sync = () => {
      prev.disabled = sc.scrollLeft <= 2;
      next.disabled = sc.scrollLeft + sc.clientWidth >= sc.scrollWidth - 2;
      nav.hidden = sc.scrollWidth <= sc.clientWidth + 2;
    };
    sc.addEventListener('scroll', sync, {passive: true});
    addEventListener('resize', sync);
    sc.parentElement.append(nav);
    sync();
  });

  /* Titres : réduire la taille tant qu'un mot dépasse la largeur (aucune coupure dans un mot) */
  const fit = () => document.querySelectorAll('.cx-h1').forEach(h => {
    h.style.fontSize = '';
    let fs = parseFloat(getComputedStyle(h).fontSize);
    while (h.scrollWidth > h.clientWidth + 1 && fs > 18) { fs -= 2; h.style.fontSize = fs + 'px'; }
  });
  fit();
  if (document.fonts) document.fonts.ready.then(fit);
  addEventListener('resize', fit);

  /* « Tous les pré-workouts » : déplier la liste */
  document.querySelectorAll('[data-cx-more]').forEach(b => b.addEventListener('click', () => {
    b.closest('.cx-all').classList.add('is-open');
    b.parentElement.remove();
  }));

  const el = document.getElementById('cmpx-data');
  const board = document.querySelector('[data-cx-board]');
  if (!el) return;
  const D = JSON.parse(el.textContent), FR = D.fr === 'fr';
  const P = Object.fromEntries(D.pots.map(p => [p.h, p]));
  const ROOK = D.pots.find(p => p.rook);
  const KS = ['citrulline', 'beta', 'taurine', 'tyrosine', 'caffeine'];
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const NB = ' ';
  const esc = s => String(s ?? '').replace(/[&<>"]/g, c => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[c]));
  const fmt = (v, u, d = 2) => {
    if (v == null) return 'ND';
    const n = u === 'mg' ? Math.round(v) : Math.round(v * 10 ** d) / 10 ** d;
    let s = u === '€' ? n.toFixed(2) : String(n);
    if (FR) s = s.replace('.', ',');
    if (u === '€') return FR ? s + NB + '€' : '€' + s;
    return u ? s + NB + u : s;
  };
  const total = p => (p.d.citrulline == null || p.d.beta == null) ? null
    : KS.reduce((s, k) => s + (k === 'caffeine' ? Math.min(p.d[k] || 0, 200) / 1000 : (p.d[k] || 0)), 0);
  const potImg = (p, cls = 'cx-pot') => p.img
    ? `<img class="${cls}" src="${esc(p.img)}" alt="${esc(p.t)}" style="--s:${p.sc}" loading="lazy" decoding="async">`
    : `<span class="${cls} cx-pot--none" aria-hidden="true">${esc(p.brand.slice(0, 2).toUpperCase())}</span>`;

  const state = board ? {a: board.dataset.a, b: board.dataset.b} : {a: null, b: null};

  /* ---------- Sélecteur à photos ---------- */
  const sorted = D.pots.filter(p => !p.rook).sort((x, y) => (x.fr_rank ?? 99) - (y.fr_rank ?? 99) || x.t.localeCompare(y.t));
  const groups = [
    [FR ? 'Les plus connus en France' : 'Best known in France', [ROOK, ...sorted.filter(p => p.fr_rank && p.fr_rank <= 15)]],
    ['Europe', sorted.filter(p => p.mk === 'eu' && !(p.fr_rank && p.fr_rank <= 15))],
    [FR ? 'États-Unis et Royaume-Uni' : 'US and UK', sorted.filter(p => p.mk !== 'eu')]
  ];
  let sheet, side;
  function buildSheet() {
    sheet = document.createElement('dialog');
    sheet.className = 'cx-sheet';
    sheet.tabIndex = -1;
    sheet.setAttribute('aria-label', FR ? 'Choisir un pré-workout' : 'Choose a pre-workout');
    sheet.innerHTML = `<div class="cx-sheet__h"><input type="search" placeholder="${FR ? 'Cherche ton pré' : 'Search your pre'}" aria-label="${FR ? 'Chercher' : 'Search'}" autocomplete="off"><button type="button" class="cx-sheet__x" aria-label="${FR ? 'Fermer' : 'Close'}">×</button></div>
      <div class="cx-sheet__body">${groups.map(([g, list]) => `<p class="cx-sheet__g">${esc(g)}</p><div class="cx-grid">${list.map(p => {
        const t = total(p);
        return `<button type="button" class="cx-card${p.rook ? ' is-rook' : ''}" data-h="${p.h}" data-q="${esc((p.t + ' ' + p.brand).toLowerCase())}"><span class="cx-card__pot">${potImg(p)}</span><small>${esc(p.brand)}</small><b>${esc(p.name)}</b><em>${fmt(t, 'g', 1)} <i>${FR ? "d'actifs" : 'actives'}</i></em></button>`;
      }).join('')}</div>`).join('')}</div>`;
    document.body.append(sheet);
    const q = $('input', sheet);
    q.addEventListener('input', () => {
      const v = q.value.trim().toLowerCase();
      $$('.cx-card', sheet).forEach(c => { c.hidden = !!v && !c.dataset.q.includes(v); });
      $$('.cx-sheet__g', sheet).forEach(g => { g.hidden = !!v; });
    });
    $('.cx-sheet__x', sheet).addEventListener('click', () => sheet.close());
    sheet.addEventListener('click', e => {
      if (e.target === sheet) return sheet.close();
      const c = e.target.closest('.cx-card');
      if (!c) return;
      sheet.close();
      choose(c.dataset.h);
    });
  }
  function openSheet(s) {
    side = s;
    if (!sheet) buildSheet();
    const cur = s === 'f' ? ($('[data-cx-cur]') || {}).dataset?.cxCur : state[s];
    $$('.cx-card', sheet).forEach(c => c.setAttribute('aria-pressed', c.dataset.h === cur));
    const q = $('input', sheet); q.value = ''; q.dispatchEvent(new Event('input'));
    sheet.showModal();
    sheet.focus(); /* pas de clavier imposé sur téléphone */
  }
  function choose(h) {
    /* Fiche : ouvrir la fiche du pot choisi */
    if (side === 'f') { if (P[h] && P[h].url) location.href = P[h].url; return; }
    const next = {...state, [side]: h};
    if (D.tool) { Object.assign(state, next); render(true); return; }
    const pair = D.pairs.find(x => (x.a === next.a && x.b === next.b) || (x.a === next.b && x.b === next.a));
    location.href = pair ? pair.url : `${D.compare}?a=${encodeURIComponent(next.a)}&b=${encodeURIComponent(next.b)}`;
  }
  $$('[data-cx-pick]').forEach(b => b.addEventListener('click', () => openSheet(b.dataset.cxPick)));

  /* ---------- Outil : mise à jour sur place ---------- */
  if (!D.tool || !board) return;
  const q = new URLSearchParams(location.search);
  if (P[q.get('a')]) state.a = q.get('a');
  if (P[q.get('b')]) state.b = q.get('b');

  const cls = (el, c) => { el.classList.remove('is-win', 'is-lose', 'is-tie', 'is-nd', 'is-rook'); if (c) el.classList.add(c); };
  function render(push) {
    const A = P[state.a], B = P[state.b];
    board.dataset.a = A.h; board.dataset.b = B.h;
    const ta = total(A), tb = total(B), tr = total(ROOK);
    [['a', A, ta, tb], ['b', B, tb, ta]].forEach(([s, p, t, o]) => {
      const sd = $(`[data-cx-side="${s}"]`, board);
      $('.cx-side__pot', sd).innerHTML = potImg(p);
      $('[data-cx-brand]', sd).textContent = p.brand;
      $('[data-cx-name]', sd).textContent = p.name;
      sd.setAttribute('aria-label', (FR ? 'Changer de pré-workout (' : 'Change pre-workout (') + p.t + ')');
      const tot = $('[data-cx-tot]', sd);
      tot.textContent = fmt(t, 'g', 1);
      cls(tot, p.rook ? 'is-rook' : t == null ? 'is-nd' : (o != null && t > o) ? 'is-win' : 'is-lose');
    });
    /* Multiplicateur */
    const box = $('[data-cx-ratio-box]', board);
    const win = ta != null && tb != null && ta !== tb ? (ta > tb ? [A, ta / tb] : [B, tb / ta]) : null;
    box.hidden = !win || !isFinite(win[1]);
    if (win && isFinite(win[1])) { $('[data-cx-ratio]', box).textContent = '×' + fmt(win[1], '', 1); $('[data-cx-ratio-who]', box).textContent = win[0].brand; }
    /* Barres */
    KS.forEach(k => {
      const r = $(`[data-cx-row="${k}"]`, board);
      const cap = v => k === 'caffeine' ? Math.min(v || 0, 200) : (v || 0);
      const va = A.d[k], vb = B.d[k], sa = cap(va), sb = cap(vb);
      const mx = Math.max(sa, sb, 0.001);
      const ca = A.rook ? 'is-rook' : va == null ? 'is-nd' : sa > sb ? 'is-win' : sa < sb ? 'is-lose' : 'is-tie';
      const cb = B.rook ? 'is-rook' : vb == null ? 'is-nd' : sb > sa ? 'is-win' : sb < sa ? 'is-lose' : 'is-tie';
      const u = k === 'caffeine' ? 'mg' : 'g';
      [['a', A, va, sa, ca], ['b', B, vb, sb, cb]].forEach(([s, p, v, sv, c]) => {
        const val = $(`[data-cx-v="${s}"]`, r), t = $(`[data-cx-t="${s}"]`, r);
        val.textContent = (k === 'citrulline' && p.mal ? '≈' : '') + fmt(v, u);
        cls(val, c); cls(t, c);
        $('i', t).style.width = (sv / mx * 100).toFixed(1) + '%';
      });
    });
    /* Le kilo d'actifs : A, B et ROOK ; le plus bas porte « Moins cher » */
    const kilo = (p, t) => p.price != null && p.serv && t ? Math.round(p.price / p.serv / t * 1000) : null;
    const ks = {a: A.rook ? null : kilo(A, ta), b: B.rook ? null : kilo(B, tb), r: kilo(ROOK, tr)};
    const kmin = Math.min(...Object.values(ks).filter(v => v != null));
    const kmax = Math.max(1, ...Object.values(ks).filter(v => v != null));
    [['a', A], ['b', B], ['r', ROOK]].forEach(([s, p]) => {
      const c = $(`[data-cx-kilo="${s}"]`);
      if (!c) return;
      c.hidden = s !== 'r' && !!p.rook;
      const k = ks[s], cheap = k != null && k === kmin;
      c.classList.toggle('is-cheap', cheap);
      $('[data-cx-brand]', c).textContent = p.brand;
      $('[data-cx-k]', c).innerHTML = k == null ? 'ND' : `${k}<span>€</span>`;
      const bd = $('.cx-k__badge', c); bd.textContent = cheap ? bd.dataset.t : '';
      const kb = $('[data-cx-kbar]', c); if (kb) kb.style.width = (k == null ? 0 : k / kmax * 100).toFixed(1) + '%';
    });
    /* Réponse courte et carte ROOK */
    const lead = $('[data-cx-lead]');
    if (lead) lead.textContent = FR
      ? `${A.t} : ${fmt(ta, 'g', 1)} d'actifs par scoop. ${B.t} : ${fmt(tb, 'g', 1)}. ROOK, qui édite ce comparateur : ${fmt(tr, 'g', 1)}.`
      : `${A.t}: ${fmt(ta, 'g', 1)} of actives per scoop. ${B.t}: ${fmt(tb, 'g', 1)}. ROOK, which publishes this comparison: ${fmt(tr, 'g', 1)}.`;
    const best = [[A, ta], [B, tb]].filter(([p, t]) => t != null && !p.rook).sort((x, y) => y[1] - x[1])[0];
    const rx = $('[data-cx-rook-x]');
    if (rx) { rx.hidden = !best; rx.textContent = best ? `×${fmt(tr / best[1], '', 1)} ${FR ? 'face à' : 'vs'} ${best[0].brand}` : ''; }
    /* Page dédiée si la paire existe */
    const pl = $('[data-cx-pairlink]'), pair = D.pairs.find(x => (x.a === A.h && x.b === B.h) || (x.a === B.h && x.b === A.h));
    if (pl) { pl.hidden = !pair; if (pair) pl.innerHTML = `<a href="${esc(pair.url)}">${esc(pair.t)}${FR ? ' : la page complète' : ': full page'}</a>`; }
    if (push) { const u = new URL(location.href); u.searchParams.set('a', A.h); u.searchParams.set('b', B.h); history.replaceState(null, '', u); }
  }
  if (state.a !== board.dataset.a || state.b !== board.dataset.b) render(false);
})();
